export const createDefaultLocationContextValue = (
    defaultValue: Location | undefined = undefined,
): Location | undefined => {
    return defaultValue;
};

export default createDefaultLocationContextValue;
